import { render } from "./privateNumber.vue?vue&type=template&id=a1312586&scoped=true"
import script from "./privateNumber.vue?vue&type=script&lang=js"
export * from "./privateNumber.vue?vue&type=script&lang=js"

import "./privateNumber.vue?vue&type=style&index=0&id=a1312586&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1312586"

export default script